import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "retrospect"
}
const _hoisted_3 = { class: "warning-img" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-charutupian" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-chakanxiangqing" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "查看图片", -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { class: "retrospect-info" }
const _hoisted_9 = { class: "retrospect-info-head" }
const _hoisted_10 = { class: "warning-desc-tag" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-chushimao2" }, null, -1)
const _hoisted_12 = { class: "retrospect-info-top" }
const _hoisted_13 = { class: "retrospect-info-address" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-daohangdizhi" }, null, -1)
const _hoisted_15 = { class: "retrospect-info-address" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-naozhong" }, null, -1)
const _hoisted_17 = ["src"]

import { ref, onMounted, nextTick } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { ImagePreview, Dialog } from 'vant'
import flvjs from 'flv.js'

import { getWarningById, delWarn } from '@/api/shop'
import { getExceptionInfo } from '@/api/ai'
import { getBase64Image } from '@/utils'
import { IRetrospect } from '@/utils/interface'
import ComHeader from '@/components/ComHeader/index.vue'
import ComVideo from '@/components/ComVideo/index.vue'
// import ComVideo2 from '@/components/ComVideo/index_test.vue'
// import imgBox from '@/components/imgBox/index.vue'
// import html2canvas from 'html2canvas'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()
const data = ref<IRetrospect>()
// const imageUrl = ref('')
// getWarningById({
//   id: route.params.id
// }).then((res: any) => {
//   data.value = res
// handleImage(res.imageUrl, () => {
//   nextTick(() => {
//     setTimeout(() => {
//       html2canvas(img.value as HTMLElement).then((pic: any) => {
//         url.value = pic.toDataURL('image/png')
//       })
//     }, 10)
//   })
// })
// })
// const playUrl = ref(
//   'https://www.cloud-dahua.com/videoPlay/live.html?url=https://flvproxy-hzpaas-hzaliedge.lechange.com:7088/localvod/c127077d5b1f714e7c6785e3c6c8eee0.flv?expire=1662015571&digest=6f5770b442a78fcc67c7e565d32e7cf4'
// )
// const flvPlayer: null | any = ref(null)
onMounted(() => {
  // if (flvjs.isSupported()) {
  //   const videoElement = document.getElementById('videoElement')
  //   flvPlayer.value = flvjs.createPlayer({
  //     type: 'flv',
  //     isLive: true,
  //     hasAudio: true,
  //     url: 'https://cmgw-vpc.lechange.com:8890/flv/LCO/6G00744PAZ8DAC9/9/1/20220727093925/8b248bb753ba37b0618df0f6f3d2192f.flv' // 自己的flv视频流
  //   })
  //   flvPlayer.value.attachMediaElement(videoElement)
  //   flvPlayer.value.load()
  //   setTimeout(() => {
  //     flvPlayer.value.play()
  //   }, 2000)
  // }
})

getExceptionInfo(route.query.token as string).then((res: any) => {
  data.value = res
})

// const handleImage = (url: string, callback: any) => {
//   const image = new Image()
//   image.setAttribute('crossOrigin', 'anonymous')
//   // @ts-ignore
//   image.src = url
//   image.onload = function () {
//     imageUrl.value = getBase64Image(image)
//     callback && callback()
//   }
// }

// const showImg = () => {
//   console.log('imageUrl', url.value)
//   url.value &&
//     ImagePreview({
//       // images: [data.value?.imageUrl],
//       images: [url.value],
//       closeable: true,
//       closeIconPosition: 'bottom-left'
//     })
// }
const showImg = () => {
  data.value &&
    ImagePreview({
      // images: [data.value?.imageUrl],
      images: [data.value.imageUrl],
      closeable: true,
      closeIconPosition: 'bottom-left'
    })
}

// const delItem = () => {
//   Dialog.confirm({
//     title: '提醒',
//     message: '是否确认删除'
//   })
//     .then(() => {
//       delWarn(route.params.id as string).then(() => {
//         router.back()
//       })
//     })
//     .catch(() => {
//       // on cancel
//     })
// }
// const img = ref<HTMLElement | null>(null)
// const url = ref('')

return (_ctx: any,_cache: any) => {
  const _component_van_image = _resolveComponent("van-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ComHeader, {
      height: 16,
      title: "预警追溯"
    }),
    (data.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_van_image, {
              width: "100%",
              height: "100%",
              fit: "cover",
              position: "center",
              src: data.value.imageUrl
            }, null, 8, ["src"]),
            _hoisted_4,
            _createElementVNode("div", {
              class: "button",
              onClick: showImg
            }, _hoisted_7)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("span", null, _toDisplayString(data.value.exceptionDescribe), 1)
              ]),
              _createElementVNode("span", null, "设备ID：" + _toDisplayString(data.value.deviceSerial), 1)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("span", null, _toDisplayString(data.value.storeName) + "/" + _toDisplayString(data.value.addressName), 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("span", null, _toDisplayString(data.value.time), 1)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (data.value && data.value.videoUrl)
      ? (_openBlock(), _createElementBlock("iframe", {
          key: 1,
          src: `https://www.cloud-dahua.com/videoPlay/live.html?type=video&url=${data.value.videoUrl}`,
          style: {"width":"100%","height":"300px"}
        }, null, 8, _hoisted_17))
      : _createCommentVNode("", true)
  ]))
}
}

})